module.exports = __webpack_public_path__ + "static/media/mouthtc.a6b032f2.png";